import { render, staticRenderFns } from "./AamsGiftRegOutStorage.vue?vue&type=template&id=e9e22aa4&scoped=true&"
import script from "./AamsGiftRegOutStorage.vue?vue&type=script&lang=js&"
export * from "./AamsGiftRegOutStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e22aa4",
  null
  
)

export default component.exports